import { element } from '@sections/cabinet/navigation';

export const LIST = 'cabinet:clients:list';
export const CREATE = 'cabinet:clients:create';
export const EDIT = 'cabinet:clients:edit';

const attract = true;

export const base = context => [
  element(context._('List'), LIST, 'notes'),
  element(context._('Add new'), CREATE, 'add', attract),
];

export const create = context => [
  element(context._('List'), LIST, 'notes'),
  element(context._('Add new'), CREATE, 'add'),
];
